import React, { useState } from "react";
import { View } from "react-native";
import { styles } from "../style/FoundryStyle";
import LeftCargaFabrica from "../components/CargaDeFabrica/ComponentButtonLeftCargaFabrica.js";
import InformacionRelevante from "../components/CargaDeFabrica/ComponentInformacionRelevante.js";
import FundicionStatus from "../components/CargaDeFabrica/ComponentFundicionStatus.js";
import RepairStatus from "../components/CargaDeFabrica/ComponentReparacionesStatus.js";
import CalculoCargaDeFabrica from "../components/CargaDeFabrica/ComponentCalculoCargaDeFabrica.js";
import AppScreenBackground from "../components/Common/ComponentAppBackground.jsx";
import InformacionEnDetalle from "../components/CargaDeFabrica/ComponentInformacionEnDetalle.js";
import InformacionEnDetalle2 from "../components/CargaDeFabrica/ComponentInformacionEnDetallerDos.js";
import ComponentAsignaciones from "../components/Asignaciones/ComponentAsignaciones.js";
import ComponentRecuperacionMerma from "../components/Metales/ComponentRecuperacionMerma.js";
import ComponentEstadoOro from "../components/CargaDeFabrica/ComponentEstadoOro.js";
import ComponentStockFornituras from "../components/CargaDeFabrica/ComponentStockFornituras.js";
export default function CargaDeFabrica({ navigation }) {
  const [activeComponent, setActiveComponent] = useState(null);

  const handleTeamSelect = (team) => {
    setActiveComponent(team);
  };

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case "Informacion Relevante":
        return <InformacionRelevante navigation={navigation} />;
      case "Reparaciones":
        return <RepairStatus navigation={navigation} />;
      case "Estado Fundición":
        return <FundicionStatus navigation={navigation} />;
      case "Estado Metales":
        return <ComponentEstadoOro navigation={navigation} />;
      case "Fornituras":
        return <ComponentStockFornituras navigation={navigation} />;
      case "Carga de Fabrica":
        return <CalculoCargaDeFabrica navigation={navigation} />;
      case "Detalle":
        return <InformacionEnDetalle navigation={navigation} />;
      case "New Details":
        return <InformacionEnDetalle2 navigation={navigation} />;
      case "Asignaciones":
        return <ComponentAsignaciones navigation={navigation} />;
      case "Rec. de Merma":
        return <ComponentRecuperacionMerma navigation={navigation} />;
      // case "Control Oro":
      //   return <ComponentControlOro navigation={navigation} />;
      default:
        return <InformacionRelevante navigation={navigation} />;
    }
  };

  return (
    <AppScreenBackground style={styles.containerNoColor}>
      <View style={styles.containerNoColor}>
        <View style={{ flexDirection: "row", marginBottom: 2 }}>
          <LeftCargaFabrica onTeamSelect={handleTeamSelect} />
        </View>

        <View style={{ flex: 1 }}>{renderActiveComponent()}</View>
      </View>
    </AppScreenBackground>
  );
}
